import type { EntityConfig } from '../types'

export const fxRateEntity: EntityConfig = {
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'active', label: 'Active' },
      { value: 'expired', label: 'Expired' },
      { value: 'pending', label: 'Pending' },
      { value: 'suspended', label: 'Suspended' },
    ],
    options: [
      { value: 'active', label: 'Active', variant: 'success' },
      { value: 'expired', label: 'Expired', variant: 'muted' },
      { value: 'pending', label: 'Pending', variant: 'warning' },
      { value: 'suspended', label: 'Suspended', variant: 'destructive' },
    ],
    mappings: {
      active: ['active'],
      expired: ['expired'],
      pending: ['pending'],
      suspended: ['suspended'],
    },
  },
  queryFields: {
    status: { type: 'status', label: 'Status' },
    sourceCurrency: { type: 'text', label: 'Source Currency' },
    targetCurrency: { type: 'text', label: 'Target Currency' },
  },
  uiFilterFields: ['status', 'sourceCurrency', 'targetCurrency'],
}
